export const formatPrice = (cents) => ((cents || 0) / 100).toFixed(2);



// WEBPACK FOOTER //
// ./components/JSON-LD/utils.js